import styled from "styled-components";

const Style = styled.div`
  flex: 1;
  border-radius: 8px;
  background: var(--base-gray-20);
  margin: var(--size) var(--size-lg);
  border: 1px solid var(--base-gray-40);

  .list {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    gap: var(--size);
    padding: var(--size-lg);

    .entity {
      background: white;
      border-radius: 8px;
      padding: var(--padding-lg);
      border: 1px solid var(--base-gray-40);
      box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.03), 0px 1px 6px -1px rgba(0, 0, 0, 0.02), 0px 2px 4px 0px rgba(0, 0, 0, 0.02);

      .entity-header {
        display: flex;
        margin-bottom: var(--size-sm);

        label {
          color: var(--base-gray-60);
          font-size: 12px;
          margin-bottom: 0px;
        }
      } 

      .entity-body {
        border-bottom: 1px solid var(--base-gray-30);
        padding-bottom: var(--size-lg);
        margin-bottom: var(--size-lg);
        display: flex;
        gap: 14px;

        .info {
          h2 {
            font-size: 20px;
            margin-bottom: 5px;
          }

          p {
            font-size: 14px;
            font-weight: 500;
            margin-bottom: 0px;
          }
        }
      }

      .entity-footer {
        display: flex;
        gap: 8px;
        
        .footer-row {
          flex: 1;
          display: flex;
          gap: 12px;

          label {
            margin-bottom: 0px;
            color: var(--base-gray-70);

            &.value {
              color: var(--base-gray-90);
            }
          }

        }
      }
    }
  }
`;

export default Style;
